$(function(){
  var modalOpened = false
  var lastFocusStatus = true;
  var isTimerActive = false;
  var inactiveModal;
  var scrollTimeout;
  var userHasScrolled = false;

  function activateTimer(){
    if(!modalOpened){
      inactiveModal = setTimeout(() => {
        if(userHasScrolled){
          modalOpened = true;
          $("#discountModal").modal("show")
        } else {
          deactivateTimer()
        }
      }, 30000);
      isTimerActive = true
      scrollTimeout = setTimeout(function(){
        userHasScrolled = false
      }, 3000)
    }
  }
  function deactivateTimer(){
    clearTimeout(inactiveModal)
    clearTimeout(scrollTimeout)
    isTimerActive = false
  }

  $("body").on("scroll mousemove", function(){
    if(!isTimerActive){
      activateTimer()
    } else {
      userHasScrolled = true;
    }
  })
  

  setInterval(function(){
    if(document.hasFocus() == lastFocusStatus) return;
    lastFocusStatus = !lastFocusStatus;
    if(!document.hasFocus()) {
      deactivateTimer()
    } else {
      activateTimer()
    }
  }, 500);

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  const cookieValue = getCookie("promoNextTime")
  if(cookieValue.length > 1){
    //check if new Date > cookieValue
    let now = new Date().getTime();
    let then = new Date(cookieValue).getTime();
    if(now > then){
      setTimeout(() => {
        $("#discountModal").modal("show")
      }, 3000);
    }
  }
})
